
import React, { lazy } from 'react'
import Form from "../components/Form";
import '../App.css';
const Calculator = lazy(() => import('../components/Calculator'));
const Faq = lazy(() => import('../components/Faq'));
// const Intrest_rate_table = lazy(() => import('../components/Intrest_rate_table'));
const Features = lazy(() => import('../components/Features'));
const Benefits = lazy(() => import('../components/Benefits'));

function Home() {

  return (
    <>
      <Form />
      <Calculator />
      {/* <Intrest_rate_table /> */}
      <Features />
      <Benefits />
      <Faq />




    </>
  );
}

export default Home;
